<template>
    <div class="vh-100 bg-grey">
        <div class="vh-100 bg-grey" id="RekapAbsen">
            <!-- HEADER -->
            <div class="header-top bg-white">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left" @click="back">
                        <div class="header-item">
                            <img src="../../../assets/icons/back-blue.svg" alt="a">
                        </div>
                    </div>
                    <div class="header-top--middle f-cont f-16 f-bold">Rekap Absensi</div>
                    <div class="header-top--right">
                        <div class="header-item">
                        </div>
                    </div>
                </div>
            </div>
            <!-- CONTENT -->
            <div class="content-wrapper main-page">
                <div class="bg-white">
                    <div class="w-limit">
                        <div class="p-x-20 p-y-16">
                            <div class="f-16 f-semi">{{nama_karyawan_rekap}}</div>
                            <div class="m-t-2">
                                <span class="f-14 f-c-midgrey"v-if="sttaus_outlet_rekap === '1'"><b>Kasir</b> {{nama_outlet_rekap}}<span class="m-l-4 m-r-4">•</span></span>
                                <span class="f-14 f-c-midgrey"v-if="sttaus_workshop_rekap === '1'"><b>Workshop</b> {{nama_workshop_rekap}}<span class="m-l-4 m-r-4">•</span></span>
                                <span class="f-14 f-c-midgrey" v-if="sttaus_kurir_rekap === '1'"><b>Sebagai
                                    Kurir</b></span>
                            </div>
                        </div>
                        <div class="separator-line"></div>
                        <div class="p-y-12 p-x-20 d-flex justify-content-between">
                            <div class="f-16 f-semi f-c-blue dropdown-toggle" @click="gosetperiode">{{Periode_Absen_rekap}}</div>
                        </div>
                        <div class="separator-line"></div>
                    </div>
                </div>

	            <div class="item-rekap-absensi-wrapper w-limit p-x-20 p-t-16">
		            <div class="d-flex-between-center">
			            <div class="f-16 f-c-midgrey">
				            {{ Masuk + Alpha + Sakit + Cuti + Libur + TanpaStatus }} Hari<span class="m-l-4 m-r-4">•</span>
				            <span class="f-c-blue f-semi" @click="lihatRingkasan">Lihat Ringkasan</span>
			            </div>
			            <div class="f-16 f-c-blue f-semi">
				            <FilterSorting @filter="filter" :jenisFilter="'absen'" :sortByColumn="'created_at'"
				                           style="margin-top: 0"
				            />
			            </div>
		            </div>
	            </div>

                <div class="item-rekap-absensi-wrapper w-limit p-x-20 p-y-20">
                    <div class="card-item" v-for="DetailRekap in Detail_Absen" @click="detailabsen(DetailRekap)">
                        <div class="top-card">
                            <div class="f-16 f-semi">{{DetailRekap.tanggal}}</div>
                            <div class="card-chevron"></div>
                        </div>
	                    <div class="d-flex-between-center">
		                    <div>
			                    <div class="f-14 f-c-midgrey m-t-4" v-if="DetailRekap.status===0">Tanpa Status</div>
			                    <div class="f-14 f-c-midgrey m-t-4" v-if="DetailRekap.status===1">Masuk Kerja</div>
			                    <div class="f-14 f-c-midgrey m-t-4 f-c-red" v-if="DetailRekap.status===2">Alpha</div>
			                    <div class="f-14 f-c-midgrey m-t-4 f-c-red" v-if="DetailRekap.status===3">Cuti</div>
			                    <div class="f-14 f-c-midgrey m-t-4 f-c-red" v-if="DetailRekap.status===4">Sakit</div>
                          <div class="f-14 f-c-midgrey m-t-4 f-c-red" v-if="DetailRekap.status===5">Libur</div>
			                    <div class="f-14 f-c-midgrey m-t-2">
				                    <span v-if="DetailRekap.status === 1">
					                    {{DetailRekap.waktuMasukRaw}}  —  {{DetailRekap.waktuPulangRaw}}
				                    </span>
			                    </div>
		                    </div>
		                    <div v-if="DetailRekap.status === 1">
			                    <div class="d-flex driver-position-relative">
				                    <div class="thumbnail-absen"
				                         :class="{'thumbnail-absen-masuk': DetailRekap.fotoAbsenKeluar !== ''}"
				                         v-if="DetailRekap.fotoAbsenMasuk !== ''"
				                         :style="{backgroundImage: 'url(' + gcsAddr + DetailRekap.fotoAbsenMasuk +')'}">
				                    </div>
				                    <div class="thumbnail-absen"
				                         v-if="DetailRekap.fotoAbsenKeluar !== ''"
				                         :style="{backgroundImage: 'url(' + gcsAddr + DetailRekap.fotoAbsenKeluar +')'}">
				                    </div>
			                    </div>
		                    </div>
	                    </div>
	                    <div v-if="DetailRekap.sumberData !== ''">
		                    <div class="separator-line m-x-min m-t-10"></div>
		                    <div class="bottom-card right m-t-10">
			                    <div class="f-regular f-c-midgrey f-12" v-html="DetailRekap.sumberData"></div>
		                    </div>
	                    </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="loadingPages">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        </div>

        <PeriodeAbsen_FromRekap v-if="issetPeriode" v-bind:class="{hidesection: !issetPeriode}" v-on:isdetail="islistnew"
                                ref="setperiode" v-bind:datalistabsen="Detail_Absen" v-on:back="islistfromclose"
                                v-bind:datarekaptoperiode="datarekap"
                                :periode_absen="periode_absen"
                                @setPeriodeAbsen="setAbsenList"
        />

	    <div class="modal fade" id="modal" role="dialog">
		    <div class="modal-dialog modal-lg  bani-modal">
			    <div class="modal-content w-limit">
				    <div class="modal-header">
					    <div class="nav-btn kiri"></div>
					    <h5 class="navbar-title text-center">Ringkasan Absensi</h5>
					    <div class="nav-btn kanan tutup">
						    <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
					    </div>
				    </div>
				    <div class="modal-body">
					    <div class="d-flex-between-center p-y-12 border-bottom">
						    <div class="f-16 f-c-midgrey">Masuk Kerja</div>
						    <div class="f-16 f-c-black">{{Masuk}} Hari</div>
					    </div>
					    <div class="d-flex-between-center p-y-12 border-bottom">
						    <div class="f-16 f-c-midgrey">Alpha</div>
						    <div class="f-16 f-c-black">{{Alpha}} Hari</div>
					    </div>
					    <div class="d-flex-between-center p-y-12 border-bottom">
						    <div class="f-16 f-c-midgrey">Sakit</div>
						    <div class="f-16 f-c-black">{{Sakit}} Hari</div>
					    </div>
					    <div class="d-flex-between-center p-y-12 border-bottom">
						    <div class="f-16 f-c-midgrey">Cuti</div>
						    <div class="f-16 f-c-black">{{Cuti}} Hari</div>
					    </div>
              <div class="d-flex-between-center p-y-12 border-bottom">
                <div class="f-16 f-c-midgrey">Libur</div>
                <div class="f-16 f-c-black">{{Libur}} Hari</div>
              </div>
					    <div class="d-flex-between-center p-y-12 border-bottom">
						    <div class="f-16 f-c-midgrey">Tanpa Status</div>
						    <div class="f-16 f-c-black">{{TanpaStatus}} Hari</div>
					    </div>

					    <div class="f-16 f-c-midgrey m-t-12">
						    <b>Tanpa status</b> merupakan status yang diberikan jika karyawan tidak melakukan absen.
						    Anda bisa mengubahnya.
					    </div>
				    </div>
			    </div>
		    </div>
	    </div>

	    <div class="modal fade" id="modalNullDataDetail" role="dialog">
		    <div class="modal-dialog modal-lg  bani-modal">
			    <div class="modal-content w-limit">
				    <div class="modal-header">
					    <div class="nav-btn kiri"></div>
					    <h5 class="navbar-title text-center">Data Tidak Ditemukan</h5>
					    <div class="nav-btn kanan tutup">
						    <img src="../../../assets/img/x2.svg" data-dismiss="modal" alt="">
					    </div>
				    </div>
				    <div class="modal-body">
					    <div class="p-d-12">
						    <b>Belum ada</b> data absensi pada periode yang anda tentukan.
						    <span v-if="tanggalTerakhirAbsen">
							    <b>Data terakhir</b> yang tersimpan adalah <b>{{ tanggalTerakhirAbsen }}</b>
						    </span>.
					    </div>
					    <div>
						    Yakin tetap ingin menampilkan data pada periode ini?
					    </div>
				    </div>
				    <div class="modal-footer">
					    <button type="button" class="btn btn-primary btn-long" data-dismiss="modal"
					            @click="dataAbsensi(true)">Tetap Tampilkan
					    </button>
				    </div>
			    </div>
		    </div>
	    </div>
    </div>
</template>
<script>
    import PeriodeAbsen_FromRekap from "./PeriodeAbsen_FromRekap";
    import FilterSorting from "@/component-items/FilterSorting";
    export default {
        name: "RekapAbsen",
        components: {FilterSorting, PeriodeAbsen_FromRekap},
        data(){
            return{
                issetPeriode:false,
                Detail_Absen:[],
                nama_karyawan_rekap:'',
                sttaus_outlet_rekap:'0',
                sttaus_workshop_rekap: '0',
                sttaus_kurir_rekap: '0',
                nama_outlet_rekap:'',
                nama_workshop_rekap:'',
                Periode_Absen_rekap:'',
                Alpha:'',
                Sakit:'',
                Masuk:'',
                Cuti:'',
                TanpaStatus:'',
                Libur:'',
	            tanggalTerakhirAbsen: '',
                format_tanggal_absensi_FR:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
	            gcsAddr: "https://storage.googleapis.com/",
	            periodeCalled: false,

	            urutan: {
		            limit: 20,
		            offset: 0,
		            length: 0,
		            pageNumber: 0,
		            sortBy: "created_at",
		            orderBy: "terbaru",
		            key: ""
	            },
            }
        },
        props:['datarekap','periode_absen'],
        mounted() {
            if(this.datarekap.filterby==='by_tahun'){
                this.GetDetailABsensiYears();
            }else if(this.datarekap.filterby==='by_bulan'){
                this.GetDetailABsensiMonth();
            }else if(this.datarekap.filterby==='by_tanggal'){
                this.GetDetailABsensiDay();
            }
        },
        methods: {
            back(){
            	this.periodeCalled = false;
                this.$emit("showkaryawanlist")
            },
            islistfromclose(){
                $('#RekapAbsen').show();
                this.issetPeriode=false;

                this.backButtonPressed(this.back)
            },
            islistnew(respon){
                // $('#RekapAbsen').show();
                // this.issetPeriode=false;
                if(this.datarekap.filterby==='by_tahun'){
                    this.GetDetailABsensiYears(respon);
                }else if(this.datarekap.filterby==='by_bulan'){
                    this.GetDetailABsensiMonth(respon);
                }else if(this.datarekap.filterby==='by_tanggal'){
                    this.GetDetailABsensiDay(respon);
                }
            },
            islist(respon){
                this.Detail_Absen = [];
                $('#RekapAbsen').show();
                this.issetPeriode=false;
                var newrespon = respon.data;
                var periode = respon.periode;
                this.Periode_Absen_rekap = periode.tanggal_formated_string;
                for (var i = 0; i < newrespon.length; i++) {
                    var kurirAbsensi = "false";
                    var statuskurirAbsensi = "false";
                    var WorkshopAbsensi = "false";
                    var statusWorkshopAbsensi = "false";
                    var OutletAbsensi = "false";
                    var statusOutletAbsensi = "false";
                    if (newrespon[i].status_kurir ===1) {
                        statuskurirAbsensi = "true";
                        kurirAbsensi = "true";
                    }
                    if (newrespon[i].status_outlet ===1) {
                        statusOutletAbsensi = "true";
                        OutletAbsensi = "true";
                    }
                    if (newrespon[i].status_workshop ===1) {
                        statusWorkshopAbsensi = "true";
                        WorkshopAbsensi = "true";
                    }
                    this.Detail_Absen.push({
                        id: newrespon[i].idkaryawan,
                        nama: newrespon[i].nama,
                        statusWorkshop: statusWorkshopAbsensi,
                        statusOutlet: statusOutletAbsensi,
                        karyawanWorkshop: newrespon[i].workshop,
                        karyawanOutlet: newrespon[i].outlet,
                        statuskurir: statuskurirAbsensi,
                        absenmasuk: newrespon[i].absen_masuk,
                        absenalpha: newrespon[i].absen_tidak_masuk,
                        filterby : periode.periode,
                        valuemonth: periode.periode_value_1,
                    })
                }
            },
            gosetperiode(){
            	this.periodeCalled = true;
                this.issetPeriode = true;
                $('#RekapAbsen').hide();

                setTimeout(() => {
	                this.backButtonPressed(this.$refs.setperiode.back_FR)
                }, 300)

                // this.$refs.setperiode.defaultpage();
                // this.$refs.setperiode.todayMonth();
                // this.$refs.setperiode.setdate();
                // this.$refs.setperiode.cekinputbulan();
            },
            detailabsen(datarekap){
				this.smartTrackingClick("detail_absen");
                this.$emit('showdetailabsen',datarekap);

			},
            expandAbsensi() {
                $("#absensi-detail--inside").toggleClass("is-open");
            },
            async GetDetailABsensiMonth(){
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                this.Detail_Absen=[];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_detail_rekap_abensi_karyawan?filter_by='
                        + this.datarekap.filterby + '&idkaryawan=' + this.datarekap.idkaryawan + '&tahun_bulan=' + this.datarekap.valuemonth
	                    + "&urutan=" + this.urutan.orderBy, this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        this.nama_karyawan_rekap = res.data.data.NamaKaryawan;
                        var DataKaryawan = res.data.data;
                        var DataRekapabsen = res.data.data.Rekapabsen;
                        this.nama_outlet_rekap = DataKaryawan.OutletKaryawan;
                        this.nama_workshop_rekap = DataKaryawan.WorkshopKaryawan;
                        this.sttaus_kurir_rekap = DataKaryawan.StatusKaryawanKurir;
                        this.sttaus_outlet_rekap = DataKaryawan.StatusKaryawanOutlet;
                        this.sttaus_workshop_rekap = DataKaryawan.StatusKaryawanWorkshop;
                        this.Periode_Absen_rekap = DataKaryawan.TanggalPeriode;
                        this.Alpha = DataKaryawan.Alpha;
                        this.Sakit = DataKaryawan.Sakit;
                        this.TanpaStatus = DataKaryawan.TanpaStatus;
                        this.Masuk = DataKaryawan.MasukKerja;
                        this.Cuti = DataKaryawan.Cuti;
                        this.Libur = (DataKaryawan.Libur != null ? DataKaryawan.Libur : 0);
	                    this.tanggalTerakhirAbsen = this.$moment(res.data.data.TanggalTerakhirAbsen.replace("T00:00:00+07:00", "")).format("DD MMMM YYYY");
                        for (var i = 0; i < DataRekapabsen.length; i++) {
                            this.Detail_Absen.push({
                                tanggal: DataRekapabsen[i].TanggalFormat,
                                status: DataRekapabsen[i].Status,
                                waktu:DataRekapabsen[i].Waktu,
	                            waktuMasuk:DataRekapabsen[i].WaktuMasuk,
	                            waktuMasukRaw: this.getDateWithTimezone(DataRekapabsen[i].WaktuMasukRaw, "HH:mm", this.getUserTimezone()),
	                            waktuPulang: (DataRekapabsen[i].WaktuPulang === " - ") ? "--:--" : DataRekapabsen[i].WaktuPulang,
	                            waktuPulangRaw: (DataRekapabsen[i].WaktuPulangRaw === null) ? "--:--" : this.getDateWithTimezone(DataRekapabsen[i].WaktuPulangRaw, "HH:mm", this.getUserTimezone()),
                                idkaryawan:DataRekapabsen[i].Idkaryawan,
                                tanggal_format:DataRekapabsen[i].Tanggal,
                                idlokasi:DataRekapabsen[i].Idlokasi,
                                tanggalAwal:DataKaryawan.TanggalAwalRange,
                                tanggalAkhir:DataKaryawan.TanggalAkhirRange,
	                            fotoAbsenMasuk: (DataRekapabsen[i].CloudBucketFotoMasuk !== "") ? DataRekapabsen[i].CloudBucketFotoMasuk + "/" + DataRekapabsen[i].CloudNameFotoMasuk : "",
	                            fotoAbsenKeluar: (DataRekapabsen[i].CloudBucketFotoPulang !== "") ? DataRekapabsen[i].CloudBucketFotoPulang + "/" + DataRekapabsen[i].CloudNameFotoPulang : "",
	                            sumberData: DataRekapabsen[i].SumberData,
                            })
                        }

	                    var total = this.Alpha + this.Sakit + this.TanpaStatus + this.Masuk + this.Cuti + this.Libur;
	                    this.dataAbsensi(!(total === this.TanpaStatus))
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
            },
            async GetDetailABsensiYears(){
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                this.Detail_Absen=[];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_detail_rekap_abensi_karyawan?filter_by='
                        + this.datarekap.filterby + '&idkaryawan=' + this.datarekap.idkaryawan + '&tahun=' + this.datarekap.valueyear
	                    + "&urutan=" + this.urutan.orderBy, this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        this.nama_karyawan_rekap = res.data.data.NamaKaryawan;
                        var DataKaryawan = res.data.data;
                        var DataRekapabsen = res.data.data.Rekapabsen;
                        this.nama_outlet_rekap = DataKaryawan.OutletKaryawan;
                        this.nama_workshop_rekap = DataKaryawan.WorkshopKaryawan;
                        this.sttaus_kurir_rekap = DataKaryawan.StatusKaryawanKurir;
                        this.sttaus_outlet_rekap = DataKaryawan.StatusKaryawanOutlet;
                        this.sttaus_workshop_rekap = DataKaryawan.StatusKaryawanWorkshop;
                        this.Periode_Absen_rekap = DataKaryawan.TanggalPeriode;
                        this.Alpha = DataKaryawan.Alpha;
                        this.Sakit = DataKaryawan.Sakit;
                        this.TanpaStatus = DataKaryawan.TanpaStatus;
                        this.Masuk = DataKaryawan.MasukKerja;
                        this.Cuti = DataKaryawan.Cuti;
	                    this.tanggalTerakhirAbsen = this.$moment(res.data.data.TanggalTerakhirAbsen.replace("T00:00:00+07:00", "")).format("DD MMMM YYYY");
                        for (var i = 0; i < DataRekapabsen.length; i++) {
                            this.Detail_Absen.push({
	                            tanggal: DataRekapabsen[i].TanggalFormat,
	                            status: DataRekapabsen[i].Status,
	                            waktu:DataRekapabsen[i].Waktu,
	                            waktuMasuk:DataRekapabsen[i].WaktuMasuk,
	                            waktuMasukRaw: this.getDateWithTimezone(DataRekapabsen[i].WaktuMasukRaw, "HH:mm", this.getUserTimezone()),
	                            waktuPulang: (DataRekapabsen[i].WaktuPulang === " - ") ? "--:--" : DataRekapabsen[i].WaktuPulang,
	                            waktuPulangRaw: (DataRekapabsen[i].WaktuPulangRaw === null) ? "--:--" : this.getDateWithTimezone(DataRekapabsen[i].WaktuPulangRaw, "HH:mm", this.getUserTimezone()),
	                            idkaryawan:DataRekapabsen[i].Idkaryawan,
	                            tanggal_format:DataRekapabsen[i].Tanggal,
	                            idlokasi:DataRekapabsen[i].Idlokasi,
	                            tanggalAwal:DataKaryawan.TanggalAwalRange,
	                            tanggalAkhir:DataKaryawan.TanggalAkhirRange,
	                            fotoAbsenMasuk: (DataRekapabsen[i].CloudBucketFotoMasuk !== "") ? DataRekapabsen[i].CloudBucketFotoMasuk + "/" + DataRekapabsen[i].CloudNameFotoMasuk : "",
	                            fotoAbsenKeluar: (DataRekapabsen[i].CloudBucketFotoPulang !== "") ? DataRekapabsen[i].CloudBucketFotoPulang + "/" + DataRekapabsen[i].CloudNameFotoPulang : "",
	                            sumberData: DataRekapabsen[i].SumberData,
                            })
                        }

	                    var total = this.Alpha + this.Sakit + this.TanpaStatus + this.Masuk + this.Cuti;
	                    this.dataAbsensi(!(total === this.TanpaStatus))
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
            },
            async GetDetailABsensiDay(){
                $('#loadingPages').show();
                $('#loadingPages').addClass('overlayLoading');
                this.Detail_Absen=[];
                try {
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/list_detail_rekap_abensi_karyawan?filter_by='
                        + this.datarekap.filterby + '&idkaryawan=' + this.datarekap.idkaryawan + '&tanggal_mulai=' + this.datarekap.valueawal
                        + '&tanggal_selesai=' + this.datarekap.valueakhir + "&urutan=" + this.urutan.orderBy, this.requestHeaders);
                    if (res.status === 200) {
                        $('#loadingPages').hide();
                        $('#loadingPages').removeClass('overlayLoading');
                        this.nama_karyawan_rekap = res.data.data.NamaKaryawan;
                        var DataKaryawan = res.data.data;
                        var DataRekapabsen = res.data.data.Rekapabsen;
                        this.nama_outlet_rekap = DataKaryawan.OutletKaryawan;
                        this.nama_workshop_rekap = DataKaryawan.WorkshopKaryawan;
                        this.sttaus_kurir_rekap = DataKaryawan.StatusKaryawanKurir;
                        this.sttaus_outlet_rekap = DataKaryawan.StatusKaryawanOutlet;
                        this.sttaus_workshop_rekap = DataKaryawan.StatusKaryawanWorkshop;
                        this.Periode_Absen_rekap = DataKaryawan.TanggalPeriode;
                        this.Alpha = DataKaryawan.Alpha;
                        this.Sakit = DataKaryawan.Sakit;
                        this.TanpaStatus = DataKaryawan.TanpaStatus;
                        this.Masuk = DataKaryawan.MasukKerja;
                        this.Cuti = DataKaryawan.Cuti;
	                    this.tanggalTerakhirAbsen = this.$moment(res.data.data.TanggalTerakhirAbsen.replace("T00:00:00+07:00", "")).format("DD MMMM YYYY");
                        for (var i = 0; i < DataRekapabsen.length; i++) {
                            this.Detail_Absen.push({
	                            tanggal: DataRekapabsen[i].TanggalFormat,
	                            status: DataRekapabsen[i].Status,
	                            waktu:DataRekapabsen[i].Waktu,
	                            waktuMasuk:DataRekapabsen[i].WaktuMasuk,
	                            waktuMasukRaw: this.getDateWithTimezone(DataRekapabsen[i].WaktuMasukRaw, "HH:mm", this.getUserTimezone()),
	                            waktuPulang: (DataRekapabsen[i].WaktuPulang === " - ") ? "--:--" : DataRekapabsen[i].WaktuPulang,
	                            waktuPulangRaw: (DataRekapabsen[i].WaktuPulangRaw === null) ? "--:--" : this.getDateWithTimezone(DataRekapabsen[i].WaktuPulangRaw, "HH:mm", this.getUserTimezone()),
	                            idkaryawan:DataRekapabsen[i].Idkaryawan,
	                            tanggal_format:DataRekapabsen[i].Tanggal,
	                            idlokasi:DataRekapabsen[i].Idlokasi,
	                            tanggalAwal:DataKaryawan.TanggalAwalRange,
	                            tanggalAkhir:DataKaryawan.TanggalAkhirRange,
	                            fotoAbsenMasuk: (DataRekapabsen[i].CloudBucketFotoMasuk !== "") ? DataRekapabsen[i].CloudBucketFotoMasuk + "/" + DataRekapabsen[i].CloudNameFotoMasuk : "",
	                            fotoAbsenKeluar: (DataRekapabsen[i].CloudBucketFotoPulang !== "") ? DataRekapabsen[i].CloudBucketFotoPulang + "/" + DataRekapabsen[i].CloudNameFotoPulang : "",
	                            sumberData: DataRekapabsen[i].SumberData,
                            })
                        }

	                    var total = this.Alpha + this.Sakit + this.TanpaStatus + this.Masuk + this.Cuti;
	                    this.dataAbsensi(!(total === this.TanpaStatus))
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPages').hide();
	                $('#loadingPages').removeClass('overlayLoading');
                }
            },
	        lihatRingkasan() {
            	$("#modal").modal("show");
	        },
	        dataAbsensi(ada) {
            	if (this.periodeCalled) {
		            if (ada) {
			            this.issetPeriode = false
			            $('#RekapAbsen').show();
			            // setTimeout(() => {
				            $("#modalNullDataDetail").modal("hide");
			            // }, 1000)
		            } else {
			            this.issetPeriode = true
			            $('#RekapAbsen').hide();
			            // setTimeout(() => {
				            $("#modalNullDataDetail").modal("show");
			            // }, 1000)
		            }
	            }
	        },

	        setAbsenList(periode_absen) {
		        this.periode_absen = periode_absen
		        if(this.periode_absen.filter_by==='year'){
			        this.datarekap.filterby = 'by_tahun'
			        this.datarekap.valueyear = this.periode_absen.year
			        this.GetDetailABsensiYears();
		        }else if(this.periode_absen.filter_by==='month'){
			        this.datarekap.filterby = 'by_bulan'
			        this.datarekap.valuemonth = this.periode_absen.month
			        this.GetDetailABsensiMonth();
		        }else if(this.periode_absen.filter_by==='periode'){
			        this.datarekap.filterby = 'by_tanggal'
			        this.datarekap.valueawal = this.periode_absen.start_date
			        this.datarekap.valueakhir = this.periode_absen.end_date
			        this.GetDetailABsensiDay();
		        }
	        },
	        filter(payload) {
		        this.urutan = payload.data
		        if(this.datarekap.filterby==='by_tahun'){
			        this.GetDetailABsensiYears();
		        }else if(this.datarekap.filterby==='by_bulan'){
			        this.GetDetailABsensiMonth();
		        }else if(this.datarekap.filterby==='by_tanggal'){
			        this.GetDetailABsensiDay();
		        }
		        $("#dropdownMenuButton-" + payload.type).html(payload.textSorting)
	        }
        }
    }
</script>
<style>
    .absensi-detail {
        position: relative;
    }
    #absensi-detail--inside {
        z-index: 9;
        position: absolute;
        transition: transform .25s ease;
        background: white;
        transform: scaleY(0);
        top: 0;
        transform-origin: top;
    }
    #absensi-detail--inside.is-open {
        display: block;
        box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.05);
        transform: scaleY(1);
    }
    .thumbnail-absen {
	    height: 40px;
	    width: 40px;
	    background-size: cover;
	    background-position: center;
	    border-radius: 50%;
	    border: 3px solid white;
    }
    .thumbnail-absen.thumbnail-absen-masuk {
	    position: absolute;
	    right: 42px;
    }
</style>